import { render, staticRenderFns } from "./ToolsNews.vue?vue&type=template&id=79388340"
import script from "./ToolsNews.vue?vue&type=script&lang=js"
export * from "./ToolsNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports